import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Divider, MenuItem, Typography } from '@mui/material';
import { gt } from '../../theme';
import { CustomerGroupBrief } from '../../types/customerGroups';
import { groupPagePath } from './groupLabels';

/** Mobil / keskeny képernyő: a hamburger-menü tetején „★ Csoportjaim” blokk (a fejlécben nincs gomb). */
export default function GroupDrawerBlock({ groups, onNavigate }: { groups: CustomerGroupBrief[]; onNavigate: () => void }) {
  if (groups.length === 0) return null;
  return (
    <Box sx={{ mb: 2 }}>
      <Typography sx={{ fontWeight: 800, color: gt.leaf, mb: 0.5 }}>★ Csoportjaim</Typography>
      {groups.map((group) => (
        <MenuItem
          key={group.id}
          component={RouterLink}
          to={groupPagePath(group.slug)}
          onClick={onNavigate}
          sx={{ borderRadius: 2, pl: 2, fontWeight: 600, color: gt.leaf }}
        >
          {group.name}
        </MenuItem>
      ))}
      <Divider sx={{ mt: 1.5 }} />
    </Box>
  );
}
